/**
 * 图片轮播指令
 *  Bai.Zhiming
 */
"use strict";
angular.module("backgroundPlayModule", []).
directive("backgroundPlay", ["$q", "$timeout", function($q, $timeout) {
  return {
    restrict: "E",
    replace: false,
    scope: {
      imgList: "=",
    },
//  template: '<div ng-style="status.divStyle"><img ng-style="status.imgStyle" class="platformBackGround" ng-src="{{item}}" ng-repeat="item in imgList"></div>',
    template: '<div class="backgorundImageBox" ng-style="status.backgroundStyle"></div>',
    link: function(scope, $element, $attrs) {
      init();
      /**
       * [init description] 初始化
       * @return {[type]} [description]
       */
      function init() {
        scope.status = {
          playIndex: 0,
          time: 5000,
          scrollTime: 500,
        };
        scope.$watch("imgList", function(newV, oldV) {
          if (newV) {
          	if(newV.length==1){
          		$timeout(function() {
          			scope.status.backgroundStyle = { backgroundImage: "url("+newV[0]+")" };
          		})
          	}else{
          		var length = newV.length;
          		var fn = function(){
          			for(let l=0;l<newV.length;l++){ 
          				setTimeout(function(){
          						var dom = $($element.find(".backgorundImageBox")[0]);
          						dom.animate({opacity:'0.1'},'slow','linear',function(){
									$timeout(function() {
          								scope.status.backgroundStyle = { backgroundImage: "url("+ newV[l] +")"};
			          				})
									dom.animate({opacity:'1'},'slow','linear')
          						})
//        						dom.fadeOut("slow",function(){
//        							$timeout(function() {
//        								scope.status.backgroundStyle = { backgroundImage: "url("+ newV[l] +")"};
//			          				})
//        							dom.fadeIn("slow");
//        						})
          				},5000*l)
          			}
          			return fn;
          		}
          		setInterval(fn(),15000)
          	}
          }
        });
//      watchImgList().then(function() {
//        setStyle();
//        play();
//        watchResize();
//        initDestroy();
//      });
      }
      /**
       * [setStyle description] 设置样式
       */
      function setStyle() {
        $timeout(function() {
          scope.status.divStyle = { width: $element.width() * scope.imgList.length,  height: "auto" };
          scope.status.imgStyle = { width: $element.width(), height: "auto" };
        });
      }
      /**
       * [watchResize description] 监控窗口重置
       * @return {[type]} [description]
       */
      function watchResize() {
        window.addEventListener("resize", setStyle);
      }
      /**
       * [play description] 播放
       * @return {[type]} [description]
       */
      function play() {
        scope.status.timeouter = $timeout(function() {
          if (scope.imgList.length > 1) {
            var left;
            var preImgIndex = scope.status.playIndex;
            if (scope.status.playIndex !== scope.imgList.length - 1) {
              scope.status.playIndex++;
              left = scope.status.playIndex * $element.width();
            } else {
              scope.status.playIndex = 0;
              left = 0;
            }
            $element.find("img").eq(preImgIndex).css("opacity", 0);
            setTimeout(function() {
              $element.find("img").eq(scope.status.playIndex).css("opacity", 1);
            }, 1000);
            $element.find("div").css("left", -left);
            setTimeout(function(){
            	play();
            },scope.status.scrollTime * 2);
          }
        }, scope.status.time);
      }
      /**
       * [initDestroy description] 销毁垃圾
       * @return {[type]} [description]
       */
      function initDestroy() {
        scope.$on(function() {
          $time.cancel(scope.status.timeouter);
          window.removeEventListener("resize", setStyle);
        });
      }
      /**
       * [watchImgList description] 监控图片列表变化if
       * @return {[type]} [description]
       */
      function watchImgList() {
        var deffer = $q.defer();
        var watcher = scope.$watch("imgList", function(newV, oldV) {
          if (newV.length > 0) {
            deffer.resolve();
            watcher();
          }
        });
        return deffer.promise;
      }
    }
  };
}]);
